export function initClarity(clarityProjectId) {
  if (!clarityProjectId) {
    console.warn('Microsoft Clarity Project ID is not provided');
    return;
  }

  (function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
  })(window, document, "clarity", "script", clarityProjectId);
}

export function identifyUser(userId, friendlyName = '') {
  if (window.clarity && userId) {
    window.clarity("identify", userId, null, null, friendlyName || undefined);
  }
}